/**
 * Shared constants for MDI package
 * These constants can be safely imported in both client and server contexts
 */

// MDI User Type Constants
export const MDI_USER_TYPES = {
  CLINICIAN: "clinician",
  CLINICIAN_NAMESPACED: "App\\Models\\Clinician",
  PATIENT: "patient",
  PATIENT_NAMESPACED: "App\\Models\\Patient",
  SUPPORT: "support",
  SUPPORT_NAMESPACED: "App\\Models\\SupportStaff",
  SUPPORT_STAFF: "support staff",
} as const;

// MDI Case Status Constants
export const CASE_STATUS = {
  REQUESTED: "requested",
  ACTIVE: "active",
  CANCELLED: "cancelled",
  COMPLETED: "completed",
} as const;

// MDI Raw Status Names (as received from API)
export const MDI_STATUS_NAMES = {
  CREATED: "created",
  ASSIGNED: "assigned",
  APPROVED: "approved",
  SUPPORT: "support",
  WAITING: "waiting",
  PROCESSING: "processing",
  CANCELLED: "cancelled",
  CANCELED: "canceled", // Alternative spelling
  COMPLETED: "completed",
} as const;